export default __webpack_public_path__ + "static/media/hippoWidth.eb0f618b.jpg";